module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Resources / Capacity")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "change": function($event) {
        return _vm.eventActivateUpdateFlag('ResourcesCapacity')
      }
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "scheduleTypeHolder col-sm-10 d-flex align-items-center mb-3"
  }, _vm._l((_vm.availabilityTypes), function(availabilityType) {
    return _c('button', {
      key: availabilityType.value,
      staticClass: "btn tertiary",
      class: {
        'selected': _vm.selectedAvailabilityType == availabilityType.value
      },
      attrs: {
        "type": "button",
        "disabled": _vm.disableAvailabilityType(availabilityType.value)
      },
      on: {
        "click": function($event) {
          return _vm.setAvailabiltyType(availabilityType)
        }
      }
    }, [_vm._v(_vm._s(availabilityType.label))])
  }), 0), _vm._v(" "), (_vm.getSelectedEvent.availabilityType == _vm.AvailabilityTypes.LIMITED_BY_RESOURCES) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-2 mb-3 fs-small dark"
  }, [_c('div', {
    staticClass: "d-inline-flex align-items-center bold mb-2"
  }, [_c('radio', {
    staticClass: "d-flex",
    attrs: {
      "value": _vm.ProductShareTypes.NOSHARE,
      "disabled": (_vm.getSelectedEvent.shareType === _vm.ProductShareTypes.NOSHARE) || (_vm.disableShareType(_vm.ProductShareTypes.NOSHARE))
    },
    model: {
      value: (_vm.getSelectedEvent.shareType),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "shareType", $$v)
      },
      expression: "getSelectedEvent.shareType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-label ml-1"
  }, [_vm._v("NO")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex align-items-center bold mb-2"
  }, [_c('radio', {
    attrs: {
      "value": _vm.ProductShareTypes.SHARE,
      "disabled": (_vm.getSelectedEvent.isPrivateEvent == true || _vm.getSelectedEvent.shareType === _vm.ProductShareTypes.SHARE) || _vm.disableShareType(_vm.ProductShareTypes.SHARE)
    },
    model: {
      value: (_vm.getSelectedEvent.shareType),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "shareType", $$v)
      },
      expression: "getSelectedEvent.shareType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-label ml-1"
  }, [_vm._v("\n                            YES. Products that use the same resource at the same time will share availability. You can set max.seats per product.\n                            "), (_vm.getSelectedEvent.isPrivateEvent == true) ? _c('small', {
    staticClass: "brand"
  }, [_vm._v("(Private events cannot share availability)")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex align-items-center bold mb-2"
  }, [_c('radio', {
    attrs: {
      "value": _vm.ProductShareTypes.VIRTUALROSTER,
      "disabled": (_vm.getSelectedEvent.shareType === _vm.ProductShareTypes.VIRTUALROSTER) || _vm.disableShareType(_vm.ProductShareTypes.VIRTUALROSTER)
    },
    model: {
      value: (_vm.getSelectedEvent.shareType),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "shareType", $$v)
      },
      expression: "getSelectedEvent.shareType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-label ml-1"
  }, [_vm._v("\n                            Virtual Roster - If a product is using the same resource at the same time, the first activity to be booked will turn the other activities unavailable to book.\n                        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.getSelectedEvent.availabilityType == _vm.AvailabilityTypes.FIXED_LIMIT) ? _c('div', {
    staticClass: "col-sm-10 d-flex align-items-center mb-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Total Capacity\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalCapacity),
      expression: "totalCapacity"
    }, {
      name: "numInt",
      rawName: "v-numInt"
    }],
    staticClass: "bg-lighter mt-1",
    attrs: {
      "type": "text",
      "size": "2",
      "disabled": true
    },
    domProps: {
      "value": (_vm.totalCapacity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalCapacity = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.getSelectedEvent.availabilityType == _vm.AvailabilityTypes.LIMITED_BY_RESOURCES) ? _c('label', [_vm._v("Capacity limit")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.getSelectedEvent.eventResources), function(resource, index) {
    return _c('div', {
      key: resource && resource.id || index,
      staticClass: "row align-items-center mt-2"
    }, [_c('div', {
      staticClass: "col-sm-6"
    }, [_c('v-select', {
      staticClass: "mr-2",
      attrs: {
        "options": _vm.resourcesToSelect,
        "label": "name"
      },
      on: {
        "input": function($event) {
          return _vm.resouceSelected(_vm.getSelectedEvent.eventResources[index])
        }
      },
      model: {
        value: (_vm.getSelectedEvent.eventResources[index]),
        callback: function($$v) {
          _vm.$set(_vm.getSelectedEvent.eventResources, index, $$v)
        },
        expression: "getSelectedEvent.eventResources[index]"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 text-right d-flex align-items-center"
    }, [(_vm.getSelectedEvent.availabilityType == _vm.AvailabilityTypes.LIMITED_BY_RESOURCES) ? _c('span', [_c('input', {
      directives: [{
        name: "numInt",
        rawName: "v-numInt"
      }, {
        name: "model",
        rawName: "v-model",
        value: (resource.maxSeats),
        expression: "resource.maxSeats"
      }],
      class: {
        'border-color-6': resource.invalid,
        'mr-1': true
      },
      staticStyle: {
        "width": "55px"
      },
      attrs: {
        "type": "text",
        "max": _vm.fetchCapacity(resource)
      },
      domProps: {
        "value": (resource.maxSeats)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(resource, "maxSeats", $event.target.value)
        }, function($event) {
          return _vm.maxSeatsChanged(resource)
        }]
      }
    }), _vm._v(" / " + _vm._s(resource.availability) + "\n                        ")]) : _vm._e(), _vm._v(" "), (resource.invalid) ? _c('span', {
      staticClass: "color-6 ml-2 fs-smaller"
    }, [_vm._v("Invalid")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('i', {
      staticClass: "ico ico-delete largest dark pointer",
      on: {
        "click": function($event) {
          return _vm.removeResource(index)
        }
      }
    })]), _vm._v(" "), (resource.isAvailable !== undefined && !resource.isAvailable) ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('span', {
      staticClass: "color-6 fs-small font-weight-600"
    }, [_vm._v("Warning! This resource is already in use at this time")])]) : _vm._e()])
  }), _vm._v(" "), (_vm.resourcesToSelect.length < 1) ? _c('div', {
    staticClass: "dark fs-small bold"
  }, [_vm._v("\n                    All resoureces are in use\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('span', {
    class: {
      'opacity-50': _vm.resourcesToSelect.length < 1
    },
    on: {
      "click": _vm.addResource
    }
  }, [_c('span', {
    staticClass: "ico-add color-1 mr-1 rounded-circle border-color-1 p-1 pointer"
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer"
  }, [_vm._v("Add New")])])]), _vm._v(" "), (_vm.validations.getSelectedEvent.resources.$invalid) ? _c('div', {
    staticClass: "color-6 my-2"
  }, [_vm._v("\n                    If availbility is \"Limited by resources\" then you need at least one resource.\n                ")]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('span', [_vm._v("Share availability with other products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Resources for this event\n                        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-391b60d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-391b60d8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaResources.vue
// module id = 1431
// module chunks = 0